
<template>
  <section>
    <h3>Nach was suchst du ?</h3>
    <input class="searchBox" v-model="searchToken" @keyup.enter="executeSearch" ref="search" >
      


    <section class="searchTable" v-if="tableData">
      <h3 v-if="tableData.length === 0">Ich konnte leider nichts finden</h3>
      <h3 v-if="tableData.length === 1">Ich habe für dich {{ tableData.length }} Pfad gefunden...</h3>
      <h3 v-if="tableData.length > 1">Ich habe für dich {{ tableData.length }} Pfade gefunden...</h3>
      <table>
        <tr v-for="record in tableData" :key="record.id">
          <td style="width:25px"><div v-bind:style="{ width:defaultColorBoxSize + 'px', height: defaultColorBoxSize + 'px', backgroundColor: record.color }"/></td>
          <td>{{ record.name }}</td>
          <td>{{ record.steps }}</td>
          <td><font-awesome-icon :icon="['fas', 'plus-circle']" class="addButton" @click="handleSelectItem(record)"/></td>
        </tr>
      </table>
    </section>
  </section>
</template>

<script>
import graphService from '../graphService/graphService.js';
// import { fetchAssets } from "../firebase/firebase";


export default {
  name: "Search",

  methods: {
    selectNode(ref, index) {
      let nodeId = this.$refs[ref][0].getSelection().nodes[0];
      this.currentSelectedNode = nodeId != null ? this.assets[index].network.nodes.get(nodeId) : null;
    },
    addAction: function() {
      console.log("addAction: ")
      // this.rowSelects.shift();
      // this.rowSelects.push(ev.value);
    },
    handleSelectItem(item){
      console.log("addAction: ", item)

      let newId = graphService.mergeGraphIntoCurrentUser(item.id)
      this.$store.commit('global/setSelectedGraph', newId);

       // you can also handle toggle action here manually to open and close dropdown
    },
    async executeSearch() {
      console.log('searching for : ', this.searchToken)


      //var result = await fetchAssets(this.schoolId).get();
      var result = graphService.searchGraphs();
      console.log("SEARCHRES: ", result)
      let assets = result.map(singleRecord => {

        let allAbstracts = '';
        for(let i=0; i < singleRecord.nodes.length; i++) {
          let singleNode = singleRecord.nodes[i];
          if(singleNode.abstract === undefined || singleNode.abstract === null) singleNode.abstract = '';
          allAbstracts += singleNode.abstract.toLowerCase();
        }

        return {
          id: singleRecord.id,
          name: singleRecord.name,
          abstracts: allAbstracts,
          steps: singleRecord.nodes.length + ' Lernschritte',
          color: singleRecord.color
        };
      });

      let token = this.searchToken.toLowerCase();
      this.tableData = assets.filter(o => o.name.toLowerCase().includes(token) || o.abstracts.includes(token));
    }
  },
  data() {
    return {
      schoolId: "e5abIXEqXZc3x5I0hYhd",
      searchToken: '',
      currentSelectedGraph: null,
      tableData: null,
      defaultColorBoxSize: 20
     };
  },
  mounted: function () {
      // this.$store.commit('global/setSelectedGraph', {});
  }
};
</script>
<style scoped>

.searchBox {
  width: 100%;
  font-size: 1.25em;
  border: 0;
  outline: 0;
  border-radius: 2px;
  height: 2rem;
  padding: 0 0.714em;
}

.tableWrapper {
  width: 100%;
}

.searchTable {
  margin-top: 2rem;
}

h3 {
  margin-left: 5px;
  font-size: 1.25em;
}

table {
  width: 100%;
  font-size: 1.25em;
   background-color: rgba(199, 199, 199, 0.1);
}

tr {
  height: 30px;

}

td {
  font-size: 1.25em;
  padding: 10px;
  width: 50%;
  display: table-cell;
  vertical-align: middle;
}


tr:hover { 
   background-color: rgba(199, 199, 199, 0.3);
}

.addButton {
  cursor:pointer;
}

</style>